import React, { useState, useEffect, ReactElement } from 'react';

import { getClassNames, formatUsername } from '../../../../../utils/util';

import './resource-views.scss';

type Props = {
  viewers?: string[];
  memberCount?: number;
  archived?: boolean;
};

const ResourceViews = ({ viewers = [], memberCount = 0, archived = false }: Props): ReactElement => {
  const [viewersToDisplay, setViewersToDisplay] = useState<string[]>([]);
  const [showViewers, setShowViewers] = useState<boolean>(false);
  const [columns, setColumns] = useState<string[][]>([]);
  const [showAll, setShowAll] = useState<boolean>(false);

  useEffect((): void => {
    if (viewers.length < 11) {
      setViewersToDisplay(viewers);
    } else if (!showAll) {
      setViewersToDisplay(structuredClone(viewers).splice(0, 10));
    } else {
      const copyOfViewers: string[] = structuredClone(viewers);
      const columns: string[][] = [];

      while (copyOfViewers.length) {
        const columnData: string[] = copyOfViewers.splice(0, 10);
        columns.push(columnData);
      }
      setColumns(columns);
    }
  }, [viewers, showAll]);

  return (
    <div className={getClassNames('resource-views', { archived })} onMouseLeave={(): void => setShowViewers(false)}>
      <div className="resource-views__view-count" onMouseEnter={(): void => setShowViewers(true)}>
        {viewers.length}/{memberCount} Views
      </div>
      {showViewers && viewers.length > 0 && (
        <div className="resource-views__viewer-container" onMouseLeave={(): void => setShowViewers(false)}>
          {!showAll &&
            viewersToDisplay.map(
              (viewer: string, index: number): ReactElement => <p key={index}>{formatUsername(viewer)}</p>
            )}

          {!showAll && viewers.length > 10 && (
            <p className="resource-views__action" onClick={(): void => setShowAll(true)}>
              Show {viewers.length - 10} More
            </p>
          )}

          {showAll && viewers.length > 10 && (
            <div className="resource-views__column-container">
              {columns.map(
                (column: string[], index: number): ReactElement => (
                  <div key={`column-${index}`} className="resource-views__column">
                    {column.map(
                      (viewer: string, index: number): ReactElement => (
                        <p key={index}>{viewer}</p>
                      )
                    )}
                  </div>
                )
              )}
            </div>
          )}

          {showAll && (
            <p className="resource-views__action" onClick={(): void => setShowAll(false)}>
              Show Less
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ResourceViews;
